let ajaxUpdate = 200
let sName = {uBboToken: 'Bbo_token'}

function delToLocalStorage(key) {
    let outVal = false
    try {
        localStorage.removeItem(key)
        outVal = true
    } catch (_) {}
    return outVal
}

function saveToLocalStorage(key, data) {
    let outVal = false
    try {
        localStorage.setItem(key, JSON.stringify(data))
        outVal = true
    } catch (_) {}
    return outVal
}

function getFromLocalStorage(key) {
    let outVal = null
    try {
        const storedData = localStorage.getItem(key)
        if (storedData !== null) {outVal = JSON.parse(storedData)}
    } catch (_) {}
    return outVal
}

function isLocal() {
    return ['localhost', '127.0.0.1', '::1'].indexOf(document.location.hostname) > -1
}

function openInNewTab(url) {window.open(url, '_blank').focus()}

const formatPhoneNumber = (value) => {
    // Удаляем все нецифровые символы
    const numbers = value.replace(/\D/g, '')

    // Если номер начинается с 7 или 8, заменяем на +7
    let formattedValue = numbers
    if (numbers.startsWith('7') || numbers.startsWith('8')) {formattedValue = '7' + numbers.substring(1)} else if (numbers.startsWith('9')) {formattedValue = '7' + numbers}

    // Ограничиваем длину (10 цифр после +7)
    formattedValue = formattedValue.substring(0, 11)

    // Применяем маску
    if (formattedValue.length === 0) {return ''}
    else if (formattedValue.length === 1) {return '+7'}
    else if (formattedValue.length <= 4) {return `+7-(${formattedValue.substring(1)}`}
    else if (formattedValue.length <= 6) {return `+7-(${formattedValue.substring(1, 4)})-${formattedValue.substring(4)}`}
    else if (formattedValue.length <= 8) {return `+7-(${formattedValue.substring(1, 4)})-${formattedValue.substring(4, 6)}-${formattedValue.substring(6)}`}
    else if (formattedValue.length <= 10) {return `+7-(${formattedValue.substring(1, 4)})-${formattedValue.substring(4, 6)}-${formattedValue.substring(6, 8)}-${formattedValue.substring(8)}`}
    else {return `+7-(${formattedValue.substring(1, 4)})-${formattedValue.substring(4, 6)}-${formattedValue.substring(6, 8)}-${formattedValue.substring(8, 10)}`}
}

export {
    ajaxUpdate, sName, isLocal, saveToLocalStorage, getFromLocalStorage, delToLocalStorage, openInNewTab, formatPhoneNumber
}
